import React from "react";
import eimg from "../Images/rebar.jpg";
import autorebar from "../Images/autorebar.png"

export default function Rebarestimation() {
  return (
    <>
      {/* ================= HERO SECTION ================= */}

      <section
        className="relative h-[420px] md:h-[500px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${autorebar})`, // Replace with your AutoCAD blueprint image later
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-slate-900/60"></div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">

          <p className="uppercase tracking-[6px] text-amber-400 font-semibold text-sm md:text-base">
            Our Services
          </p>

          <h1 className="mt-4 text-4xl md:text-6xl font-bold text-white">
            Rebar Estimation
          </h1>

          <div className="w-24 h-1 bg-amber-500 rounded-full my-6"></div>

          <p className="max-w-3xl text-lg md:text-2xl text-gray-200 leading-8">
            Accurate Reinforcing Steel Estimation Services for
            Commercial, Residential, Industrial and Infrastructure
            Projects following
            <span className="font-semibold text-white">
              {" "}ACI / CRSI{" "}
            </span>
            &
            <span className="font-semibold text-white">
              {" "}RSIC Standards
            </span>.
          </p>

          {/* Breadcrumb */}

        </div>
      </section>
      {/* ================= REBAR ESTIMATION SECTION ================= */}

      <section className="bg-white py-24">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <div className="grid lg:grid-cols-2 gap-20 items-center">

            {/* Left Image */}

            <div className="relative">

              <img
                src={eimg}
                alt="Rebar Estimation"
                className="rounded-2xl shadow-2xl w-full object-cover"
              />

              {/* Decorative Line */}



            </div>

            {/* Right Content */}

            <div>

              <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-[2px] bg-amber-500"></div>

                <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
                  Our Expertise
                </span>
              </div>

              <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-4 mb-8">
                Rebar Estimation
              </h2>

              <p className="text-gray-600 leading-8 text-lg mb-10">
                We deliver precise reinforcing steel estimation services using
                advanced software and experienced engineering professionals.
                Every estimate is prepared with accuracy to minimize material
                waste, improve project planning and reduce construction costs.
              </p>

              <div className="space-y-5">

                {[
                  "Reinforcing Steel Estimating",
                  "Material Quantity Take-offs",
                  "Change Order Estimation",
                  "Bar Bending Schedule",
                  "aSa™ Software Estimation",
                  "Customer FTP File Sharing",
                  "Document Printing & Scanning",
                  "Independent Quantity Verification",
                ].map((service, index) => (

                  <div
                    key={index}
                    className="flex items-start gap-4"
                  >

                    <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">

                      <span className="text-amber-600 font-bold">
                        ✓
                      </span>

                    </div>

                    <p className="text-gray-700 text-lg">
                      {service}
                    </p>

                  </div>

                ))}

              </div>

            </div>

          </div>

        </div>

      </section>
      {/* ================= SPECIALIZATION ================= */}

      <section className="bg-gray-50 py-24">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <div className="text-center mb-16">

            <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
              What We Estimate
            </span>

            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-4">
              Our Specialization
            </h2>

            <p className="mt-6 max-w-3xl mx-auto text-gray-600 text-lg leading-8">
              We provide complete reinforcing steel quantity take-offs and estimation
              services for all types of reinforced concrete structures.
            </p>

          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">

            {[
              {
                title: "Foundation Works",
                items: [
                  "Isolated Footings",
                  "Continuous Footings",
                  "Pile Caps",
                  "Raft Foundations",
                ],
              },

              {
                title: "Structural Elements",
                items: [
                  "Columns",
                  "Beams",
                  "Walls",
                  "Slabs",
                ],
              },

              {
                title: "Infrastructure",
                items: [
                  "Bridges",
                  "Retaining Walls",
                  "Water Treatment Plants",
                  "CMU Walls",
                ],
              },

              {
                title: "Commercial Buildings",
                items: [
                  "Metal Deck",
                  "Tilt-Up Panels",
                  "Staircases",
                  "Site Works",
                ],
              },

              {
                title: "Bar Detailing",
                items: [
                  "Bar Bending Schedule",
                  "Bar Listing",
                  "Shape Codes",
                  "Cut Lengths",
                ],
              },

              {
                title: "Project Deliverables",
                items: [
                  "Quantity Take-Offs",
                  "Change Orders",
                  "Material Reports",
                  "Cost Estimation",
                ],
              },

            ].map((card, index) => (

              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition duration-300 p-8 border border-gray-100"
              >

                <h3 className="text-2xl font-bold text-slate-900 mb-6">
                  {card.title}
                </h3>

                <ul className="space-y-3">

                  {card.items.map((item, i) => (

                    <li
                      key={i}
                      className="flex items-center gap-3 text-gray-700"
                    >
                      <span className="w-6 h-6 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-sm font-bold">
                        ✓
                      </span>

                      {item}
                    </li>

                  ))}

                </ul>

              </div>

            ))}

          </div>

        </div>

      </section>
    </>
  );
}